export default {"src":"/login-app/[GIT_HASH]/_next/static/media/sync_alt.1531a816.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};